<div>
  <div [class]="headerClass">Allow your provider to use a transcription tool to generate a summary of your visit?</div>
  <div [class]="bodyClass">
    This will enable your provider to focus more on you and less on note taking. You can always change your mind.
    <a *ngIf="showScribeFaq" target="_blank" href="/scribe-faq" data-cy="scribe-learn-more-btn">Learn More</a>
  </div>
</div>
